module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "demo-item",
    style: (_vm.itemStyle)
  }, [_c('div', {
    staticClass: "demo-prop-item title"
  }, [_c('span', {
    staticClass: "num-bg"
  }, [_vm._v(_vm._s(_vm.num))]), _c('button', {
    staticClass: "delete-btn",
    on: {
      "click": _vm.itemOnClick
    }
  }, [_vm._v("X")])]), _c('div', {
    staticClass: "demo-prop-item"
  }, [_c('span', {
    staticClass: "item-prop-text"
  }, [_vm._v("order:")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.itemProps.order),
      expression: "itemProps.order",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.itemProps.order)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.itemProps.order = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _c('div', {
    staticClass: "demo-prop-item"
  }, [_c('span', {
    staticClass: "item-prop-text"
  }, [_vm._v("flex-grow:")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.itemProps.flexGrow),
      expression: "itemProps.flexGrow",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "type": "number",
      "min": "0"
    },
    domProps: {
      "value": (_vm.itemProps.flexGrow)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.itemProps.flexGrow = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _c('div', {
    staticClass: "demo-prop-item"
  }, [_c('span', {
    staticClass: "item-prop-text"
  }, [_vm._v("flex-shrink:")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.itemProps.flexShrink),
      expression: "itemProps.flexShrink",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "type": "number",
      "min": "0"
    },
    domProps: {
      "value": (_vm.itemProps.flexShrink)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.itemProps.flexShrink = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _c('div', {
    staticClass: "demo-prop-item"
  }, [_c('span', {
    staticClass: "item-prop-text"
  }, [_vm._v("flex-basis:")]), _c('input', {
    ref: "basisInput",
    domProps: {
      "value": _vm.itemProps.flexBasis
    },
    on: {
      "change": function($event) {
        _vm.updateFlexBasis($event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "demo-prop-item"
  }, [_c('span', {
    staticClass: "item-prop-text"
  }, [_vm._v("align-self:")]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.itemProps.alignSelf),
      expression: "itemProps.alignSelf"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.itemProps.alignSelf = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.alignSelfArr), function(opt) {
    return _c('option', [_vm._v(_vm._s(opt))])
  }))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-626e63c3"}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Item.vue
// module id = 99
// module chunks = 1